import { Link, useNavigate } from "react-router-dom";
import { Minus, Plus, X } from "lucide-react";
import { Sheet, SheetContent, SheetTitle } from "../ui/sheet";
import { useCart } from "../../context/CartContext";
import { PRODUCT, formatPrice, getColor, productUrl } from "../../data/catalog";

const Line = ({ item, update, close }) => {
  const c = getColor(item.colorId);
  return (
    <li className="flex gap-4 border-b border-line py-5" data-testid={`cart-item-${c.id}`}>
      <Link to={productUrl(c.id)} onClick={close} className="h-24 w-24 shrink-0 bg-white"><img src={c.image} alt={c.name} className="h-full w-full object-contain" /></Link>
      <div className="flex flex-1 flex-col">
        <div className="flex justify-between gap-2">
          <div>
            <p className="font-display text-lg leading-tight text-ink">{PRODUCT.name}</p>
            <p className="text-xs text-graphite">{c.name}</p>
          </div>
          <button aria-label="Remove" data-testid={`cart-remove-${c.id}`} onClick={() => update(c.id, 0)} className="h-6 text-graphite hover:text-ink"><X className="h-4 w-4" /></button>
        </div>
        <div className="mt-auto flex items-center justify-between">
          <div className="flex items-center border border-line">
            <button aria-label="Decrease" data-testid={`cart-dec-${c.id}`} onClick={() => update(c.id, item.qty - 1)} className="grid h-8 w-8 place-items-center"><Minus className="h-3 w-3" /></button>
            <span className="w-8 text-center text-sm" data-testid={`cart-qty-${c.id}`}>{item.qty}</span>
            <button aria-label="Increase" data-testid={`cart-inc-${c.id}`} onClick={() => update(c.id, item.qty + 1)} className="grid h-8 w-8 place-items-center"><Plus className="h-3 w-3" /></button>
          </div>
          <span className="text-sm text-ink">{formatPrice(item.qty * PRODUCT.price)}</span>
        </div>
      </div>
    </li>
  );
};

export const CartDrawer = () => {
  const { items, update, subtotal, open, setOpen, count } = useCart();
  const nav = useNavigate();
  const close = () => setOpen(false);
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent side="right" data-lenis-prevent className="flex w-full flex-col border-line bg-ivory p-0 sm:max-w-md" data-testid="cart-drawer">
        <div className="border-b border-line px-6 py-5">
          <SheetTitle className="font-display text-2xl font-normal text-ink">Your bag <span className="font-mono text-xs text-graphite">({count})</span></SheetTitle>
        </div>
        {items.length === 0 ? (
          <div className="flex flex-1 flex-col items-center justify-center gap-5 px-8 text-center">
            <img src="/img/emblem.png" alt="" className="h-16 w-16 opacity-80" />
            <p className="font-display text-2xl text-ink">Your bag is empty.</p>
            <Link to="/shop" onClick={close} data-testid="cart-empty-shop-link" className="btn-dark">Shop the collection</Link>
          </div>
        ) : (
          <>
            <ul className="flex-1 overflow-y-auto px-6">{items.map((i) => <Line key={i.colorId} item={i} update={update} close={close} />)}</ul>
            <div className="space-y-4 border-t border-line px-6 py-6">
              <div className="flex justify-between text-sm"><span>Subtotal</span><span data-testid="cart-subtotal">{formatPrice(subtotal)}</span></div>
              <p className="text-xs text-graphite">Shipping and taxes calculated at checkout.</p>
              <button data-testid="cart-checkout-button" onClick={() => { close(); nav("/checkout"); }} className="btn-dark w-full">Checkout</button>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
};
